import { useMemo } from 'react'

import { Market } from '../constants/markets'
import { Collateral, CurrencyId } from '../constants/tokens'
import useCollaterals from './useCollaterals'
import useMarkets from './useMarkets'

export default function useCurrencies(): Record<CurrencyId, Market | Collateral> {
  const markets = useMarkets()
  const collaterals = useCollaterals()
  return useMemo(() => ({ ...markets, ...collaterals }), [markets, collaterals])
}
